export const getAccessToken = () => {
  return (
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token")
  );
};

export const getRefreshToken = () => {
  return localStorage.getItem("refresh_token");
};

/** @param {boolean} persistent - false uses sessionStorage (tab-only) when "Remember me" is off */
export const setAccessToken = (token, persistent = true) => {
  if (persistent) {
    localStorage.setItem("access_token", token);
    sessionStorage.removeItem("access_token");
  } else {
    sessionStorage.setItem("access_token", token);
    localStorage.removeItem("access_token");
  }
};

export const setRefreshToken = (token) => {
  localStorage.setItem("refresh_token", token);
};

export const clearAuthTokens = () => {
  localStorage.removeItem("access_token");
  sessionStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};
  